/* Isabelle Quinn product cards: photo dots on swipe + Quick Buy size pop-up. */
(function(){
  if (window.__iqk) return; window.__iqk = true;

  /* Dots follow the swipe */
  document.addEventListener('scroll', function(e){
    var t = e.target; if (!t || !t.classList || !t.classList.contains('iqk-track')) return;
    var dots = t.parentNode.querySelectorAll('.iqk-dots span'); if (!dots.length) return;
    var i = Math.round(t.scrollLeft / (t.clientWidth || 1));
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('on', k === i);
  }, true);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  function money(c){
    var v = c / 100, whole = c % 100 === 0;
    try { return new Intl.NumberFormat('en-AU', {style:'currency', currency:cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2}).format(v); }
    catch(e){ return '$' + (whole ? v.toFixed(0) : v.toFixed(2)); }
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  var m, lastFocus;
  function build(){
    m = document.createElement('div');
    m.className = 'iqk-qm';
    m.setAttribute('role','dialog'); m.setAttribute('aria-modal','true'); m.setAttribute('aria-labelledby','iqk-qm-t');
    m.innerHTML = '<div class="iqk-qm__bg" data-x></div><div class="iqk-qm__panel" tabindex="-1">' +
      '<button type="button" class="iqk-qm__x" data-x aria-label="Close">&times;</button>' +
      '<div class="iqk-qm__head"><img alt="" hidden><div><p class="iqk-qm__t" id="iqk-qm-t"></p><p class="iqk-qm__p"></p></div></div>' +
      '<div class="iqk-qm__body"></div><p class="iqk-qm__msg" role="status" aria-live="polite"></p>' +
      '<div class="iqk-qm__done"><a href="' + root + 'cart">View bag</a><button type="button" data-x>Keep shopping</button></div>' +
      '<a class="iqk-qm__more" href="#">View full details</a></div>';
    document.body.appendChild(m);
    m.addEventListener('click', function(e){ if (e.target.closest('[data-x]')) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && m.classList.contains('open')) close(); });
  }
  function close(){
    m.classList.remove('show');
    setTimeout(function(){ m.classList.remove('open','added'); }, 300);
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function open(handle, url, btn){
    if (!m) build();
    lastFocus = btn;
    var body = m.querySelector('.iqk-qm__body'), msg = m.querySelector('.iqk-qm__msg');
    m.classList.remove('added'); msg.textContent = ''; body.innerHTML = '<p class="iqk-qm__l">Loading sizes…</p>';
    m.querySelector('.iqk-qm__t').textContent = ''; m.querySelector('.iqk-qm__p').textContent = '';
    m.querySelector('.iqk-qm__more').href = url || (root + 'products/' + handle);
    m.classList.add('open'); requestAnimationFrame(function(){ m.classList.add('show'); });
    document.documentElement.style.overflow = 'hidden';
    m.querySelector('.iqk-qm__panel').focus();

    fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function(r){ if (!r.ok) throw 0; return r.json(); }).then(function(p){
      m.querySelector('.iqk-qm__t').textContent = p.title;
      m.querySelector('.iqk-qm__p').textContent = (p.price_varies ? 'From ' : '') + money(p.price);
      var img = m.querySelector('.iqk-qm__head img');
      if (p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.hidden = false; } else { img.hidden = true; }

      var v = p.variants || [];
      if (v.length === 1) {
        var ok = v[0].available;
        body.innerHTML = '<button type="button" class="iqk-qm__single" data-v="' + v[0].id + '"' + (ok ? '' : ' disabled') + '>' + (ok ? 'Add to bag' : 'Sold out') + '</button>';
      } else {
        var oi = 0;
        (p.options || []).forEach(function(o, i){ if (/size/i.test(o.name || o)) oi = i; });
        var opt = p.options[oi], name = (opt && opt.name) || 'Size', vals = (opt && opt.values) || [];
        var html = '<p class="iqk-qm__l">Select ' + esc(name.toLowerCase()) + '</p><div class="iqk-qm__sizes">';
        vals.forEach(function(val){
          var match = v.filter(function(x){ return x.options[oi] === val; });
          var pick = match.filter(function(x){ return x.available; })[0];
          html += '<button type="button" class="iqk-qm__s"' + (pick ? ' data-v="' + pick.id + '"' : ' disabled aria-label="' + esc(val) + ', sold out"') + '>' + esc(String(val).replace(/^AU\s*/i, '')) + '</button>';
        });
        body.innerHTML = html + '</div>';
      }
    }).catch(function(){
      body.innerHTML = ''; msg.textContent = 'Sizes could not load. Tap View full details to choose your size.';
    });
  }

  function add(id, el){
    var msg = m.querySelector('.iqk-qm__msg');
    el.classList.add('busy'); msg.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: Number(id), quantity: 1}]})})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){
        msg.textContent = 'Added to your bag.'; m.classList.add('added');
        return fetch(root + 'cart.js').then(function(r){ return r.json(); }).then(function(cart){
          var n = cart.item_count;
          [].forEach.call(document.querySelectorAll('[data-cart-count],[data-header-cart-count],.cart-count,.header__cart-count,.cart-count-bubble span'), function(c){ c.textContent = n; });
          ['theme:cart:refresh','cart:refresh','cart:updated','theme:cart:change'].forEach(function(ev){ document.dispatchEvent(new CustomEvent(ev, {bubbles:true, detail:{cart: cart}})); });
          /* Open the same slide-out bag every add-to-bag uses */
          var drawer = document.querySelector('cart-drawer');
          if (drawer) { close(); setTimeout(function(){ drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); }, 380); }
        });
      })
      .catch(function(err){ msg.textContent = (err && (err.description || err.message)) || 'That size could not be added. Please try again.'; })
      .then(function(){ el.classList.remove('busy'); });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-iqk-qb]');
    if (b) { e.preventDefault(); e.stopPropagation(); open(b.getAttribute('data-iqk-qb'), b.getAttribute('data-url'), b); return; }
    if (m && m.classList.contains('open')) {
      var s = e.target.closest('.iqk-qm [data-v]');
      if (s && !s.disabled) add(s.getAttribute('data-v'), s);
    }
  });
})();
